import { useState, useEffect } from 'react'
import SpinnerPage from '@components/spinner/SpinnerFullPage'
import useSWR from 'swr'
import storage from '@utils/localStorage'
import checkLogin from '@utils/checkLogin'
import MessageHelper from '@utils/messageHelper'
import useRedirectBack from '@hooks/useRedirectBack'
import useT from '@hooks/useTranslation'
import { apiFetcherPost } from '@api/apiFetcher'

import { LOGIN_PAGE } from '@constants/routes' // USER_MY_DATA_LOCATION

const CHECK_LOCATIONS = false   // <- turn this off after Google-based location component is on
const CHECK_USER = false        // <- turn this off to accommodate login-less offer publication

const withOfferPostRequrementsFulfilled = (TargetComponent) =>
    (props) => {
        const { data: user } = useSWR('user', storage)
        const isReady = typeof user !== 'undefined'
        const [redirect, setRedirect] = useRedirectBack()
        const [path, setPath] = useState(null)

        const isLoggedIn = checkLogin(user)
        const tryLoginLess = isReady && !isLoggedIn && !CHECK_USER
        const requestTempUserTokenLink = tryLoginLess && `/api/user/request_temp_token`
        const { data: tempUser, error } = useSWR(requestTempUserTokenLink, apiFetcherPost)

        const zalogujSie = useT('Musisz się zalogować')
        const ustawLokalizacje = useT('Zanim dodasz ogłoszenie, ustaw lokalizacje i współrzędne geograficzne')

        useEffect(() => {
            if (isReady) {
                if (!isLoggedIn && CHECK_USER) {
                    setRedirect()
                    MessageHelper.message(zalogujSie)
                    setPath(LOGIN_PAGE)

                    //
                } else if (isLoggedIn && CHECK_LOCATIONS) {
                    const hasMainLocation = Boolean(user?.location)
                    const hasLocations = Boolean(user?.locations && user.locations.length)

                    if ((!hasMainLocation || !hasLocations)) {
                        setRedirect()
                        MessageHelper.message(ustawLokalizacje)
                        setPath(USER_MY_DATA_LOCATION)
                    }
                }
            }
        }, [isReady])

        if (path) return redirect(path)
        if (!isReady) return null
        if (tryLoginLess) { //
            const fetchingTempUser = !tempUser && !error
            return fetchingTempUser
                ? <SpinnerPage />
                : <TargetComponent {...props} user={tempUser} isLoggedIn='sortof' isTempUser={true} /> // user={user} isLoggedIn={isLoggedIn}
        }

        return <TargetComponent {...props} user={user} isLoggedIn={isLoggedIn} />
    }

export default withOfferPostRequrementsFulfilled